import enums from "./../enums";

const deposit = (
	state = {
		loading: false,
		bonus: {
			list: [],
		},
		paymentMethods: [],
		bankList: [],
		odendibilBanks: [],
	},
	{ type, payload }
) => {
	switch (type) {
		case enums.DEPOSIT_LOADING:
			return { ...state, loading: payload };
		case enums.DEPOSIT_PAYMENT_METHODS:
			return { ...state, paymentMethods: payload };
		case enums.BANK_LIST:
			return { ...state, bankList: Object.values(payload) };
		case enums.ODENDIBIL_BANKS:
			return { ...state, odendibilBanks: Object.values(payload) };
		default:
			return { ...state };
	}
};

export default deposit;
